import { FontType, TextAlign } from '@modusign/react-signing/types';

import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import SigningDateFieldPlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/SigningDateFieldPlaceholder';
import { useTransformTextStyle } from '@app/features/apply-react-signing/libs/hooks/useTransFormTextStyle';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

interface SigningDateFieldMousePlaceholderProps {
  size: AbsoluteSize;
  fontFamily: FontType;
  fontSize: number;
  required: boolean;
  textAlign: TextAlign;
  participantOrder: number;
  dateFormat: string;
  scale: number;
}

const defaultProps = {
  latestFieldData: null,
  participantOrder: 1,
  scale: 1,
};

function SigningDateFieldMousePlaceholder({
  dateFormat,
  size,
  fontFamily,
  fontSize,
  required,
  textAlign,
  participantOrder,
  scale,
}: SigningDateFieldMousePlaceholderProps) {
  const fontPixelSize = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);
  const { transformTextStyle } = useTransformTextStyle({
    size,
    fontFamily,
    fontSize,
    textAlign,
    scale,
  });

  return (
    <SigningDateFieldPlaceholder
      dateFormat={dateFormat}
      fontPixelSize={fontPixelSize}
      participantOrder={participantOrder}
      rootElementSize={size}
      star={required}
      style={transformTextStyle}
    />
  );
}

SigningDateFieldMousePlaceholder.defaultProps = defaultProps;

export default SigningDateFieldMousePlaceholder;
